import { EAsidePanelProperty } from '../../../../../../asidePanel/components/AsidePanel/types';
import { EKanbanCardProperty } from '../../../../../../../../../types/types';

export const getPreviewKey = (
    key: EAsidePanelProperty | EKanbanCardProperty,
): EKanbanCardProperty => {
    if (key === EAsidePanelProperty.CARD_ASSIGNEES) {
        return EKanbanCardProperty.ASSIGNEES;
    } else if (key === EAsidePanelProperty.CARD_TAGS) {
        return EKanbanCardProperty.TAGS;
    } else if (key === EAsidePanelProperty.CARD_START_DATE) {
        return EKanbanCardProperty.START_DATE;
    } else if (key === EAsidePanelProperty.CARD_DUE_DATE) {
        return EKanbanCardProperty.DUE_DATE;
    } else if (key === EAsidePanelProperty.CARD_ESTIMATE) {
        return EKanbanCardProperty.ESTIMATE;
    }
    return key as EKanbanCardProperty;
}
